import React, { useEffect, useState } from "react";
import useAuth from "@/hooks/useAuth";
import AppLoading from "@/components/AppLoading";

export default function EntraCallback() {
  const auth = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function handleCallback() {
      try {
        const success = await auth.handleEntraCallback();
        if (cancelled) return;

        if (success) {
          const redirectUri = sessionStorage.getItem("redirectUri") || "/";
          window.location.replace(redirectUri);
        } else {
          setError("Login failed. Please try again.");
        }
      } catch (err: any) {
        if (cancelled) return;
        console.error("[EntraCallback] Error:", err);
        setError(err?.message || "Login failed. Please try again.");
      }
    }

    handleCallback();

    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    const appUrl = window.location.origin;
    const fullReset = () => {
      try {
        sessionStorage.clear();
        // Wipe MSAL state so the next login starts from a clean slate
        const keysToRemove: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
          const k = localStorage.key(i);
          if (k && (k.startsWith("msal.") || k.includes(".msal.") || k === "velaro.msalLoginStartedAt")) {
            keysToRemove.push(k);
          }
        }
        keysToRemove.forEach(k => localStorage.removeItem(k));
      } catch { /* ignore */ }
      window.location.replace("/");
    };
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
          <img src="/img/velaro.svg" alt="Velaro" className="h-8 mx-auto mb-4" />
          <p className="text-sm text-gray-500 mb-1">Velaro Admin</p>
          <div className="text-red-500 text-xl mb-3">Login Failed</div>
          <p className="text-gray-600 mb-4">{error}</p>
          <p className="text-xs text-gray-500 mb-6">
            Your login session may have expired. Bookmark the URL below and click
            <span className="font-medium"> Start Fresh </span>to reset.
          </p>
          <div className="text-xs bg-gray-50 border border-gray-200 rounded px-3 py-2 mb-4 font-mono break-all">
            {appUrl}
          </div>
          <button
            onClick={fullReset}
            className="w-full bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 text-sm font-medium"
          >
            Start Fresh
          </button>
          <a href={appUrl} className="block mt-3 text-xs text-gray-500 hover:text-gray-700">
            Or return to {appUrl}
          </a>
        </div>
      </div>
    );
  }

  return <AppLoading />;
}
